export function trashDirective() {
    return {
        restrict: 'E',
        replace:true,
        scope: {
            title: '@',
            fnDropActivity: '&onDropActivity',
            fnDragOver: '&onDragOver'
        },
        template: '<div class="trash" tooltip="">' +
                        '<i class="glyphicon glyphicon-trash"></i>' + '<p>drop & erase</p>' +
                    '</div>',
        link: function(scope, element) {
            const onDropActivity = scope.fnDropActivity();
            const onDragOver = scope.fnDragOver();

            element.bind('drop', function(event){

                event.preventDefault();
                event.stopPropagation();

                event.target.classList.remove('drag');
                //jquery wrap the original event
                onDropActivity(event.originalEvent);
            });

            element.bind('dragover', function(event) {
                event.preventDefault();
                event.stopPropagation();

                // event.target.classList.add('dragover');
                //jquery wrap the original event
                onDragOver(event.originalEvent);
            });
            element.bind('dragenter', function(event){
                event.preventDefault();
                event.stopPropagation();
                event.target.classList.add('drag');
            });
            element.bind('dragleave', function(event){
                event.preventDefault();
                event.stopPropagation();
                event.target.classList.remove('drag');
            });
        }
    }
}
